// extracted by mini-css-extract-plugin
export default {"modal":"app-lists-FolderEditModal-FolderEditModal-module__tJ45MyIMxvCbPcc6ZO8l","field":"app-lists-FolderEditModal-FolderEditModal-module__f_kh4BQrwLmVktUZJmyb"};